import React from 'react';

import { RecordIcon, SvgView } from 'components/presenters/icons';
import { MD_ICON } from 'consts';
import { useAppStore } from 'hooks';
import { getMDIconPath } from 'utils';

import { Props } from '../../types';

import styles from './CardTitleStaticView.module.scss';

function CardTitleStaticView({
  title,
  isRecord,
  seasonEpisodeTitle,
  isSeriesType,
  isMosaicProgram,
}: Props) {
  const {
    appStore: { staticAssetsUrl },
  } = useAppStore();

  return (
    <div aria-hidden data-type='cardBubbleStaticInfo' className={styles.wrapper}>
      <div className={styles.titleWrapper}>
        <h3>{title}</h3>
        {isMosaicProgram && (
          <span className={styles.mosaicIcon}>
            <SvgView url={`${staticAssetsUrl}${getMDIconPath(MD_ICON)}`} />
          </span>
        )}
        {isRecord && (
          <span data-type="recordIndication" className={styles.recordIcon}>
            <RecordIcon active multiple={isSeriesType} />
          </span>
        )}
      </div>
      {seasonEpisodeTitle && <p>{seasonEpisodeTitle}</p>}
    </div>
  );
}

export default CardTitleStaticView;
